import React from 'react';
import { getLoginBootstrapUrl } from 'ts/config/ConfigService';
import WashingMachine from 'images/washing_machine.svg';
import { CardStackSection, Card, Stack, Heading, Text, Button } from '@origin-digital/ods-core';

export const PermissionErrorPage: React.FC = () => (
  <CardStackSection>
    <Card padding="medium">
      <Stack space={['large', 'xlarge']} alignX="center">
        <img src={WashingMachine} width="129px" height="144px" alt="Washing machine" />
        <Stack space={['medium', 'large']}>
          <Heading data-id="error-title" variant="h3" align="center">
            Looking for My Account?
          </Heading>
          <Text data-id="error-msg" align="center">
            Sorry, this link won’t take you there. To see more in My Account, just log in below.
          </Text>
        </Stack>
        <Button data-id="error-back-button" href={getLoginBootstrapUrl()} variant="outlined">
          Log in
        </Button>
      </Stack>
    </Card>
  </CardStackSection>
);
